import store from './vueX/store'

function tokenHasExpired() {
	const tokenExpirationDate = new Date(
		store.state.token.accessTokenExpiration
		).getTime()
		const dateRightNow = new Date().getTime()
	if (dateRightNow > tokenExpirationDate) {
		return true
	} else {
		return false
	}
}

// function refreshTokenBeforeRequest (request) {
// 	if (tokenHasExpired()) {
// 		window.console.warn('Token expired')
// 		store.dispatch('POST_REFRESH_TOKEN')
// 		.then( resp => {
// 			if (resp) {
// 				request()
// 			} else {
// 				// resolve(false);
// 			}
// 		})
// 	} else {
// 		request()
// 	}
// }

export { tokenHasExpired }
